<template>
    <div>
        <b-row>
            <b-col cols="12" md="6" lg="6">
                <app-form-text-input
                    label="Nombre"
                    id="name"
                    :required="true"
                    :hasError="$v.thePhone.name.$error"
                    errorMessage="Debe escribir el nombre del contacto"
                    @input="$v.thePhone.name.$touch()"
                    v-model="thePhone.name"
                >
                </app-form-text-input>
            </b-col>
            <b-col cols="12" md="6" lg="6">
                <app-form-text-input
                    label="Número"
                    id="name"
                    :required="true"
                    :hasError="$v.thePhone.number.$error"
                    errorMessage="Debe escribir el número del contacto"
                    @input="$v.thePhone.number.$touch()"
                    v-model="thePhone.number"
                >
                </app-form-text-input>
            </b-col>
            <b-col cols="12" md="12" lg="12">
                <app-form-textarea-input
                    label="Descripción"
                    id="description"
                    v-model="thePhone.description"
                >
                </app-form-textarea-input>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import storesRepository from "../../../../../repositories/stores.repository";
import { required } from "vuelidate/lib/validators";
export default {
    props: {
        store: {
            required: false
        },
        myPhone: {
            required: false
        },
        onSave: {
            type: Function
        },
        onEdit: {
            type: Function
        }
    },
    watch: {
        myPhone(val) {
            this.fillForm();
        }
    },
    data() {
        return {
            thePhone: {
                name: "",
                number: "",
                description: "",
                storeId: ""
            }
        };
    },
    validations: {
        thePhone: {
            number: { required },
            name: { required }
        }
    },
    methods: {
        savePhone() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }

            this.thePhone.storeId = this.store.id;

            const sr = { ...storesRepository };
            sr.saveStorePhone(this.thePhone)
                .then(({ data }) => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.cleanFields();
                        typeof this.onSave === "function" &&
                            this.onSave(data.phone);
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("Error al guardar el teléfono");
                });
        },
        updatePhone() {
            this.$v.thePhone.$touch();
            if (this.$v.thePhone.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }

            this.thePhone.storeId = this.store.id;

            const sr = { ...storesRepository };
            sr.updateStorePhone(this.thePhone, this.myPhone.id)
                .then(({ data }) => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.cleanFields();
                        typeof this.onEdit === "function" &&
                            this.onEdit(data.phone);
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("Error al modificar el comercio");
                });
        },
        saveOrUpdate() {
            if (!!this.myPhone) {
                this.updatePhone();
            } else {
                this.savePhone();
            }
        },
        fillForm() {
            if (Object.keys(this.myPhone).length !== 0) {
                this.thePhone.storeId = this.myPhone.store_id;
                this.thePhone.name = this.myPhone.name;
                this.thePhone.number = this.myPhone.number;
                this.thePhone.description = this.myPhone.description;
            } else {
                this.cleanFields();
            }
        },
        cleanFields() {
            Object.keys(this.thePhone).map(key => (this.thePhone[key] = ""));
            this.$nextTick(() => {
                this.$v.$reset();
            });
        }
    },
    created() {
        this.$bus.$on("store-phone-form.save", this.saveOrUpdate);
        this.$bus.$on("store-phone-form.clean", this.cleanFields);
    },
    beforeDestroy() {
        this.$bus.$off("store-phone-form.save");
    }
};
</script>
